import React, { useEffect, useState } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RxCross2 } from "react-icons/rx";
import { Col, Row } from "react-bootstrap";
import { BiUpload } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";

import { MdCancel } from "react-icons/md";
import "react-quill/dist/quill.snow.css";

import {
  ref,
  getDownloadURL,
  deleteObject,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";

import { toast } from "react-toastify";
import { DashboardBoxStyle } from "../../../../SideBar/SidepanelStyled";
import {
  CreateBlog,
  createPodcast,
  getPodcastById,
  updatePodcastById,
} from "../../../../util/Auth/APIs";
import { LoadingPage } from "../../../../Components/Loading/Loading";
import TopHeader from "../../../../Components/TopHeader/TopHeader";
import SelectAllCategories from "../Category/SelectAllCategories";

const EditInsightPodcast = () => {
  const [submitloader, setSubmitLoader] = useState(false);
  const [imageloader, setImageloader] = useState(false);
  const [deleteloader, setDeleteLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [tags, setTags] = useState([]);

  const { id } = useParams();

  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const [magzineDetails, setMagzineDetails] = useState({
    isPublished: true,
    podcastTitle: "",
    category: "",
    category2: "",
    category3: "",
    category4: "",
    podcastDescription: "",
    podcastLink: "",
    keywords: [],
    type: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "isPublished") {
      setMagzineDetails({ ...magzineDetails, [name]: e.target.checked });
    } else if (name === "blogVideos" || name === "keywords") {
      setMagzineDetails({ ...magzineDetails, [name]: [e.target.value] });
    } else {
      setMagzineDetails({ ...magzineDetails, [name]: value });
    }
  };

  const Boxmodules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],['link', 'image'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const handleQuill = (content, delta, source, editor) => {
    setMagzineDetails({
      ...magzineDetails,
      podcastDescription: editor.getHTML(),
    });
    setValue(editor.getHTML());
  };

  function handleKeyDown(e) {
    if (e.key === "Enter" || e.type === "click") {
    e.preventDefault(); // Prevent form submission
    const value = e.target.parentElement.querySelector('.input-tag').value.trim();
      if (value === '') return;
      ;
     

        const updatedTags = [...tags, value];
        setTags(updatedTags);
        setMagzineDetails({ ...magzineDetails, keywords: updatedTags });
 e.target.parentElement.querySelector('.input-tag').value = '';

    }
  }

  function removeTag(index) {
    const updatedTags = tags.filter((el, i) => i !== index);
    setTags(updatedTags);
    setMagzineDetails({ ...magzineDetails, keywords: [...updatedTags] });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
        id: id,
        data: {
            isPublished: magzineDetails?.isPublished,
            title: magzineDetails?.podcastTitle,
            category: magzineDetails?.category,
            category2: magzineDetails?.category2,
            category3: magzineDetails?.category3,
            category4: magzineDetails?.category4,
            description: value,
            link: magzineDetails?.podcastLink,
            keywords: magzineDetails?.keywords,
            type: magzineDetails?.type,
          },
      };
  


    setSubmitLoader(true);
    try {
      const response = await updatePodcastById(payload);
      toast.success("Podcast Updated Successfully");
      setSubmitLoader(false);
      navigate(-1);
      console.log(response);
    } catch (error) {
      setSubmitLoader(false);
      toast.error("Something went wrong");
      console.log(error);
    }
  };

  useEffect(() => {
    console.log(magzineDetails.magzineImages);
  }, [magzineDetails.magzineImages]);

  const singlePodcast = async () => {
    setLoader(true);
    try {
      const res = await getPodcastById(id);
      setMagzineDetails({
        isPublished: res?.data?.message?.isPublished,
        podcastTitle: res?.data?.message?.title,
        category: res?.data?.message?.category,
        category2: res?.data?.message?.category2,
        category3: res?.data?.message?.category3,
        category4: res?.data?.message?.category4,
        podcastDescription: res?.data?.message?.description,
        podcastLink: res?.data?.message?.link,
        keywords: res?.data?.message?.keywords,
        type: res?.data?.message?.type
      });

      setLoader(false);
      console.log(res.data.message);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    singlePodcast();
  }, []);
  useEffect(() => {
    setTags(magzineDetails?.keywords);
  }, [magzineDetails?.keywords.length]);
  return (
    <>
      {loader ? (
        <LoadingPage />
      ) : (
        <form onSubmit={handleSubmit}>
          <DashboardBoxStyle className="scroller">

           <TopHeader headerTitle={"Edit Podcast"} type="back"/>

            <div className="form-container position-relative mt-4">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                defaultChecked={magzineDetails?.isPublished ? true : false}
                onChange={handleChange}
                className="hr-select"
                name="isPublished"
                id=""
              />

              <span className="ispublished-text">
                Do you want to add this in company view page
              </span>
            </div>
              {/* --------------  Blog Title ----------- */}
              <div className="d-flex mt-4 align-items-center">
                <div className="profile-input-head">
                  <h6>Podcast Title</h6>
                </div>
                <div className="profile-input-width">
                  <div className="profile-input-field">
                    <input
                      onChange={handleChange}
                      value={magzineDetails?.podcastTitle}
                      name="podcastTitle"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex mt-4 align-items-center">
                <div className="profile-input-head">
                  <h6>Podcast Link</h6>
                </div>
                <div className="profile-input-width">
                  <div className="profile-input-field">
                    <input
                      onChange={handleChange}
                      value={magzineDetails?.podcastLink}
                      name="podcastLink"
                      type="text"
                      placeholder="Add Link"
                    />
                  </div>
                </div>
              </div>

              <SelectAllCategories
                selected={magzineDetails}
                setSelected={setMagzineDetails}
              />



              <div className="d-flex mt-4 align-items-center">
            <div className="profile-input-head">
              <h6>Type</h6>
            </div>
            <div className="profile-input-width">
              <div className="profile-input-field">
                <select   onChange={handleChange} required name="type" id="">
                  <option value={magzineDetails?.type} selected disabled>
                    select
                  </option>
                  <option value="Public">Public</option>
                  <option value="Private">Private</option>
                </select>
              </div>
            </div>
          </div>


              {/* -------------- Blog Description ----------- */}
              <div className="d-flex mt-4 align-items-center">
                <div className="profile-input-head">
                  <h6>Keywords</h6>
                </div>
                <div className="tags-container">
                  {tags.map((tag, index) => (
                    <div className="tag-item" key={index}>
                      <span className="text">{tag}</span>
                      <span className="close" onClick={() => removeTag(index)}>
                        &times;
                      </span>
                    </div>
                  ))}
                  <input
                   
                    type="text"
                    className="input-tag"
                    placeholder="Add Keywords"
                  />
                   <p onClick={handleKeyDown} className="add-btn">
                Add
              </p>
                </div>
                
              </div>

              

              {/* --------------   Content ----------- */}
              <div className="d-flex mt-4 align-items-center">
                <div className="profile-input-head">
                  <h6>Podcast Discription</h6>
                </div>

                <div className="profile-input-width">
                  <ReactQuill
                    style={{ background: "white" }}
                    theme="snow"
                    modules={Boxmodules}
                    value={magzineDetails.podcastDescription}
                    onChange={handleQuill}
                    placeholder="Description"
                  />
                  {/* <div className='profile-input-field'>
                                      <input onChange={handleChange} name="content" type="text" />
                                  </div> */}
                </div>
              </div>

              <div className="mt-5 d-flex justify-content-end common-submit-button">
                <button>
                  {submitloader ? (
                    <div
                      className="spinner-border text-white ml-4"
                      role="status"
                    ></div>
                  ) : (
                    <> Save & Publish</>
                  )}
                </button>
              </div>

              <div
                onClick={() => navigate(-1)}
                className="close-job cross-sign-pos"
              >
                <RxCross2 />
              </div>
            </div>
          </DashboardBoxStyle>
        </form>
      )}
    </>
  );
};

export default EditInsightPodcast;
